<div>
  @for (item of list; track item; let i = $index) {
  <div [attr.data-index]="i">
    @if (i < 3) {
    <div class="spaced-list-element">
      {{ item }}
    </div>
    } @if (!collapsed) {
    <div>
      @if (i >= 3) {
      <div class="spaced-list-element">
        {{ item }}
      </div>
      }
    </div>
    }
  </div>
  } @if (list.length > 3) {
  <div class="spaced-list-element">
    <a [routerLink]="[]" (click)="toggleCollapsed()">
      {{ collapsed === true ? "Show more" : "Show less" }}
    </a>
  </div>
  }
</div>
